import React, { useMemo, useState } from 'react';
import { isMobile, useGameResultStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { BetType, REC_BET_DATA_MODEL_MAP } from '../../../enums/tableNumbers';
import { doChipStore } from '../../../store/doChipStore';
import { useRouletteDoBetValidation } from '../../../hooks/useRouletteDoBetValidation';
import { uuid } from '../../../helpers/uuid';
import { COLOR_BY_NUMBER } from '../../../enums/colorByNumber';

export const LastResults = observer(({ handleMouseLeave, handleMouseMove }) => {
  const { gameResults } = useGameResultStore();
  const { selectedChip } = doChipStore;
  const { handleDoBetWithValid } = useRouletteDoBetValidation();
  const [activeNumberTitle, setActiveNumberTitle] = useState(null);

  const numberList = useMemo(() => {
    return gameResults
      .filter((item) => item.roundData)
      .slice(0, 10)
      .map((item) => item.roundData.number);
  }, [gameResults]);

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute('data');
    const model = REC_BET_DATA_MODEL_MAP[valueType];
    if (model) {
      const nextChipModel = {
        [model.type]: selectedChip,
        chipType: model.type,
      };
      if (selectedChip) {
        handleDoBetWithValid(nextChipModel);
      }
    }
  };

  return (
    <div
      className='roulette-mobile-number-ins'
      onClick={handleDoChip}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {numberList.map((item, index) => (
        <div
          onClick={() => setActiveNumberTitle(index)}
          className={`roulette-mobile-number-item  ${activeNumberTitle === index && isMobile() ? 'active' : ''} ${
            COLOR_BY_NUMBER[item].color
          } 
          `}
          data={BetType[`StraightUp_${item}`]}
          key={uuid()}
        >
          <span data={BetType[`StraightUp_${item}`]} className={COLOR_BY_NUMBER[item].color}>
            {item}
          </span>
        </div>
      ))}
    </div>
  );
});
